module.exports = __webpack_public_path__ + "static/img/VRRoad.a1431c70.png";